import { Pencil } from 'lucide-react';
import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import styles from './EditSegment.module.css';

interface SegmentNameDescriptionProps {
  name: string;
  description: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  disabled?: boolean;
  /** When true (e.g. create mode), start with the form open so user can fill name/description */
  defaultEditing?: boolean;
}

export const SegmentNameDescription: React.FC<SegmentNameDescriptionProps> = ({
  name,
  description,
  onNameChange,
  onDescriptionChange,
  disabled = false,
  defaultEditing = false,
}) => {
  const [isEditing, setIsEditing] = useState(defaultEditing);

  return (
    <section className={styles.nameDescriptionSection}>
      <div className={styles.nameDescriptionHeader}>
        <h2 className={styles.nameDescriptionTitle}>Segment details</h2>
        {!isEditing && (
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => setIsEditing(true)}
            disabled={disabled}
            className={styles.editDetailsButton}>
            <Pencil />
            Edit name & description
          </Button>
        )}
      </div>

      {isEditing ? (
        <div className={styles.nameDescriptionEdit}>
          <label className={styles.fieldLabel} htmlFor="segment-name">
            Name
          </label>
          <input
            id="segment-name"
            type="text"
            value={name}
            onChange={e => onNameChange(e.target.value)}
            placeholder="Segment name"
            className={styles.nameInput}
            autoFocus
          />
          <label className={styles.fieldLabel} htmlFor="segment-description">
            Description
          </label>
          <textarea
            id="segment-description"
            value={description}
            onChange={e => onDescriptionChange(e.target.value)}
            placeholder="Add a description..."
            className={styles.descriptionInput}
            rows={3}
          />
          <div className={styles.editActions}>
            <Button type="button" variant="outline" size="sm" onClick={() => setIsEditing(false)}>
              Done
            </Button>
          </div>
        </div>
      ) : (
        <div className={styles.nameDescriptionView}>
          <p className={styles.nameDisplay}>{name || 'Untitled segment'}</p>
          <p className={styles.descriptionDisplay}>{description || 'No description'}</p>
        </div>
      )}
    </section>
  );
};
